const SITE_ORIGIN = "https://www.ccobandcompany.com";

export function absoluteUrl(path: string) {
  return `${SITE_ORIGIN}${path.startsWith("/") ? path : `/${path}`}`;
}

export function routeMeta(path: string, type: "website" | "article" = "website") {
  return [
    { property: "og:url", content: absoluteUrl(path) },
    { property: "og:type", content: type },
    { name: "twitter:card", content: "summary_large_image" },
  ];
}

export function canonicalLinks(path: string) {
  return [{ rel: "canonical", href: absoluteUrl(path) }];
}

const LABELS: Record<string, string> = {
  about: "About", services: "Services", accounting: "Accounting", auditing: "Auditing",
  taxation: "Taxation", bookkeeping: "Bookkeeping", payroll: "Payroll", "tax-planning": "Tax Planning",
  "tax-preparation": "Tax Preparation", "business-formation": "Business Formation",
  "small-business": "Small Business", "part-time-cfo": "Part-Time CFO", "tax-center": "Tax Center",
  calculators: "Financial Calculators", resources: "Resources", "cities-we-serve": "Cities We Serve",
  faq: "FAQ", contact: "Contact", gallery: "Gallery", blog: "Blog", reviews: "Reviews",
  links: "Useful Links", privacy: "Privacy Policy", terms: "Terms & Conditions", disclaimer: "Disclaimer",
};

export function breadcrumbJsonLd(path: string, currentTitle?: string) {
  const segments = path.split("/").filter(Boolean);
  if (segments.length === 0 || segments[0] === "admin" || segments[0] === "api") return null;
  const items = [{ "@type": "ListItem", position: 1, name: "Home", item: absoluteUrl("/") }];
  let current = "";
  segments.forEach((segment, index) => {
    current += `/${segment}`;
    items.push({
      "@type": "ListItem",
      position: index + 2,
      name: index === segments.length - 1 && currentTitle ? currentTitle : LABELS[segment] ?? segment.replace(/-/g, " "),
      item: absoluteUrl(current),
    });
  });
  return { "@context": "https://schema.org", "@type": "BreadcrumbList", itemListElement: items };
}